import React from 'react';
import { CtaBlock } from '../CtaBlock';
const trust = ['Accesso immediato', 'Accesso a vita', 'Garanzia di 7 giorni'];
export function FinalCta() {
  return <section className="bg-ink-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-122" data-mp="22fyvg8ha0ym2">
      <div className="mx-auto max-w-2xl text-center" data-id="element-123" data-mp="1no6puo7aayxj">
        <p className="font-display text-xs font-bold uppercase tracking-[0.22em] text-forge-light" data-id="element-124" data-mp="1snt1it7gs748">
          🔥 La prossima volta che accenderai la tua saldatrice…
        </p>
        <h2 className="mt-3 font-display text-3xl font-bold uppercase leading-tight text-bone sm:text-5xl" data-id="element-125" data-mp="1eqo056ip3wfb">
          Puoi continuare a improvvisare…
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-mute sm:text-lg" data-id="element-126" data-mp="14rf84j7e4rvl">
          Oppure puoi iniziare con un sistema che ti aiuta a sapere esattamente cosa controllare
          prima di cominciare.
        </p>
        <p className="mt-3 text-[15px] font-medium leading-relaxed text-bone/90 sm:text-lg" data-id="element-127" data-mp="2z4y0zfqh7mak">
          Apri il Sistema Maestro di Saldatura™, trova le informazioni di cui hai bisogno e inizia a
          saldare con maggiore precisione, controllo e sicurezza.
        </p>

        <div className="mt-8" data-id="element-128" data-mp="3ted3vgpsspx9">
          <CtaBlock note="" data-id="element-129" data-mp="3tdbpb29kplas" />
        </div>

        <p className="mt-7 font-display text-sm font-bold uppercase tracking-[0.18em] text-mute" data-id="element-130" data-mp="b1ychzwrn94g">
          Pagamento unico di
        </p>
        <p className="font-display text-5xl font-bold leading-none text-bone sm:text-7xl" data-id="element-131" data-mp="70d52u303n1n">
          $27 <span className="text-2xl text-mute sm:text-3xl" data-id="element-132" data-mp="3fg6mdb55p2jr">USD</span>
        </p>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5" data-id="element-133" data-mp="3ahlmxdxqamwd">
          {trust.map(item => <li key={item} className="text-[12px] font-semibold text-mute sm:text-sm" data-id="element-134" data-mp="3oh4k5bp04dtw">
              <span className="text-arc-light" data-id="element-135" data-mp="3jg6ygp4s91nn">✓</span> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}